import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./components/About";
import Footer from "./components/Footer";
import ContactUs from "./components/ContactUs";
import ExploreAll from "./components/ExploreAll";
import WomenSelect from "./components/WomenSelect";
import MenSelect from "./components/MenSelect";
import WomenSetSelect from "./components/WomenSetSelect";

import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome
import './App.css'; // Make sure this contains .whatsapp-btn CSS

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category1" element={<WomenSelect />} />
        <Route path="/category2" element={<MenSelect />} />
        <Route path="/category3" element={<WomenSetSelect />} />
        <Route path="/About" element={<About />} />
        <Route path="/ExploreAll" element={<ExploreAll />} />
        <Route path="/ContactUs" element={<ContactUs />} />
      </Routes>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919739620009"  // Replace with your phone number
        className="whatsapp-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
